import { AssistanceRoute } from './containers';
import { IModule } from 'core/rootInterfaces/root.interface';

export const assistanceModule: IModule = {
  moduleName: 'assistance',
  path: '/assistance',
  component: AssistanceRoute,
  reducer: null,
};
